import { defaultSpringCrisisLine, employeeSpringCrisisLine } from 'constants/strings';
import { useIsInternalMember } from 'src/shared/hooks/useIsInternalMember';
export var useCrisisSupportForMember = function (memberId) {
    return useIsInternalMember(memberId) ? employeeSpringCrisisLine : defaultSpringCrisisLine;
};
